'use client'

import Cookie from 'js-cookie'
import { useEffect, useState } from 'react'

import CookieBar from './CookieBar'
import { CookieConsentValues } from './CookieConstent.types'
import CookieSettingsPanel from './CookieSettingsPanel'

const defaultConsent: CookieConsentValues = {
  necessary: true,
  statistic: false,
  preferences: false,
  marketing: false,
}

const COOKIE_NAME = 'cookie_consent'

export const CookieConsent = () => {
  const [showBar, setShowBar] = useState(false)
  const [showPanel, setShowPanel] = useState(false)
  const [consent, setConsent] = useState<CookieConsentValues>(defaultConsent)

  useEffect(() => {
    const saved = Cookie.get(COOKIE_NAME)
    if (!saved) {
      setShowBar(true)
    } else {
      try {
        const parsed = JSON.parse(saved) as CookieConsentValues
        if (!parsed.necessary) setShowBar(true)
      } catch {
        setShowBar(true)
      }
    }
  }, [])

  const handleAcceptAll = () => {
    const newConsent: CookieConsentValues = {
      necessary: true,
      statistic: true,
      preferences: true,
      marketing: true,
    }
    Cookie.set(COOKIE_NAME, JSON.stringify(newConsent), { expires: 365 })
    setShowBar(false)
    setShowPanel(false)
  }

  const handleSaveSettings = () => {
    Cookie.set(COOKIE_NAME, JSON.stringify(consent), { expires: 365 })
    setShowBar(false)
    setShowPanel(false)
  }

  return (
    <>
      {showBar && !showPanel && (
        <CookieBar
          onAcceptAll={handleAcceptAll}
          onSettingsClick={() => setShowPanel(true)}
        />
      )}
      {showPanel && (
        <CookieSettingsPanel
          consent={consent}
          setConsent={setConsent}
          onSave={handleSaveSettings}
          onCancel={() => setShowPanel(false)}
        />
      )}
    </>
  )
}

export default CookieConsent
